import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import PersonalInfo from '../views/PersonalInfo.vue';
import authUtils from '@/utils/auth';
import LogoutApi from '@/api/logout';
import { redirectToOnboardingWhenNoToken } from '@/config/authRedirect';
import PersonalInfoStep3Content from "@/components/PersonalInfoStep3Content.vue";
import FormFlow from "@/views/FormFlow.vue";
import Dialog from "@/views/Dialog.vue";
import test from "@/views/test.vue";
import Xf from "@/views/Xf.vue";
import ImageGallery from "@/views/ImageGallery.vue";
const routes = [
    {
        path: '/',
        name: 'Onboarding',
        component: PersonalInfo,
        meta: { requiresGuest: true } // 需要未登录状态
    },
    {
        path: '/personal-info',
        name: 'PersonalInfo',
        component: PersonalInfo,
        meta: { requiresAuth: true } // 需要登录状态
    },
    {
        path: '/test',
        name: 'test',
        component: test,
        meta: { requiresAuth: true } // 需要登录状态
    },
    {
        path: '/test2',
        name: 'test2',
        component: PersonalInfoStep3Content,
        meta: { requiresAuth: true } // 需要登录状态
    },
    {
        path: '/form-flow',
        name: 'FormFlow',
        component: FormFlow,
        meta: { requiresAuth: true } // 需要登录状态
    },
    {
        path: '/dialog',
        name: 'Dialog',
        component: Dialog,
        meta: { requiresAuth: true } // 需要登录状态
    },
    {
        path: '/test3',
        name: 'Dialog2',
        component: Xf,
        meta: { requiresAuth: true } // 需要登录状态
    },
    {
        path: '/gallery',
        name: 'ImageGallery',
        component: ImageGallery,
        meta: { requiresAuth: false } // 不需要登录
    }
];
const history = process.env.NODE_ENV === 'production'
    ? createWebHashHistory(process.env.BASE_URL)
    : createWebHistory(process.env.BASE_URL);
const router = createRouter({
    history,
    routes
});
// 路由守卫
router.beforeEach((to, from, next) => {
    // Debug: log current redirect flag to verify runtime value
    console.log('redirectToOnboardingWhenNoToken =', redirectToOnboardingWhenNoToken);
    // If user is not logged in and redirection is enabled, redirect to Onboarding unless already there
    if (!authUtils.isLoggedIn() && redirectToOnboardingWhenNoToken && to.path !== '/' && to.path !== '/logout') {
        next('/');
        return;
    }
    if (to.path === '/logout') {
        LogoutApi.logout().then(() => {
            authUtils.clearAuth();
            next('/');
        }).catch(() => {
            authUtils.clearAuth();
            next('/');
        });
        return;
    }
    const isLoggedIn = authUtils.isLoggedIn();
    // 如果路由需要登录但用户未登录
    if (to.meta.requiresAuth && !isLoggedIn && redirectToOnboardingWhenNoToken) {
        console.log('未登录，跳转到登录页面');
        next('/');
        return;
    }
    // 如果路由需要未登录状态但用户已登录
    if (to.meta.requiresGuest && isLoggedIn) {
        console.log('已登录，跳转到个人信息页面');
        next('/personal-info');
        return;
    }
    next();
});
export default router;
